<template>
  <div class="page-content flex flex-column height-100">
    <a-row class="mobile-sticky">
      <a-col :span="24">
        <a-form class="col-12" >
            <a-row :gutter="20">
                <template v-if="!isTrainee">
                    <a-col :span="24" :md="6">
                        <a-form-item class="filter-select" label='Class'>
                            <cvc-select :options="comp_classOptions" :optionGroups="true" v-model="data_form.class" placeholder="Select class"/>
                        </a-form-item>
                    </a-col>
                    <a-col :span="24" :md="6">
                        <a-form-item class="filter-select" label='Students'>
                            <cvc-select :options="comp_studentOptions" v-model="data_form.student" placeholder="Select class" :disabled="!comp_studentOptions.length" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="24" :md="6"></a-col>
                </template>
                
                <a-col :span="24" :md="6">
                    <a-form-item class="filter-select" label='Filter'>
                        <cvc-select :options="taskOptions" v-model="data_form.task" placeholder="Select class"  :disabled="!comp_studentOptions.length"/>
                    </a-form-item>
                </a-col>
            </a-row>
        </a-form>
      </a-col>
    </a-row>
    <a-row class="height-100 mt3 mobile-offset mobile-card" :gutter="16"  v-if="comp_student">
      <a-col :span="24" :md="16" class="height-100">
        <a-card class="height-100">
            <cvc-line-chart v-if="comp_student && comp_chartData.chart && comp_chartData.chart.series && comp_chartData.chart.series.length" slot="cover" class="width-100" :title="`${comp_student.firstName} ${comp_student.lastName} compaired to rest of class`" :legend="[`${comp_student.firstName} ${comp_student.lastName}`, 'Class average']" :chart="comp_chartData.chart" />
        </a-card>
      </a-col>
      <a-col :span="24" :md="8" class="height-100">
        <a-card class="height-100">
            <template  v-if="comp_student">
                <a-row>
                    <a-col :span="24">
                        <cvc-data-block title="Name">{{ comp_student.firstName }} {{ comp_student.lastName }}</cvc-data-block>
                    </a-col>
                </a-row>
                 <a-row class="mt2" :gutter="16">
                    <a-col :span="12">
                        <cvc-data-block title="Attempts" :solid="true">{{ comp_studentSessions.length }}</cvc-data-block>
                    </a-col>
                    <a-col :span="12">
                        <cvc-data-block title="Success percentage" :show-status="true" :status="comp_studentPassed >= 80" :solid="true">{{ comp_studentPassed }}%</cvc-data-block>
                    </a-col>
                 </a-row>
                 <a-divider />
                 <a-row class="mt2" :gutter="16">
                    <a-col :span="24">
                        <h3>Procedure time</h3>
                    </a-col>
                    <a-col :span="12">
                        <cvc-data-block title="Student" :solid="true">{{ comp_chartData.student }}</cvc-data-block>
                    </a-col>
                    <a-col :span="12">
                        <cvc-data-block title="Class" :solid="true">{{ comp_chartData.class }}</cvc-data-block>
                    </a-col>
                 </a-row>
            </template>
        </a-card>
      </a-col>
    </a-row>
    <loading v-if="data_loading"/>
  </div>
</template>

<script>
import cvcSelect from '@/components/Select';
import cvcLineChart from '@/components/LineChart';
import cvcDataBlock from '@/components/DataBlock';
import { getUsers, getClasses } from '@/utils/databaseUtils';
import { formatChart, sortTasks, minToSec, secToMin } from '@/utils/formatUtils';

export default {
    name: 'Cohort',
    components: {
        cvcSelect,
        cvcLineChart,
        cvcDataBlock
    },
    props: {
        taskOptions: {
            type: Array,
            required: true
        },
        user: {
            type: Object,
            required: true
        },
        isTrainee: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            data_loading: false,
            data_students: [],
            data_sessions: [],
            data_form: {
                class: '',
                student: '',
                task: 'averageTime'
            }
        }
    },
    methods: {
        func_selectFunction(option) {
            const format = {
                averageTime: (timeSeries) => timeSeries.reduce((total, time) => total + time, 0) / timeSeries.length,
                lastTime: (timeSeries) => timeSeries[timeSeries.length - 1],
                bestTime: (timeSeries) => timeSeries.reduce((best, time) => {
                    if (best > time && time > 0) best = time;
                    return best
                }, 10000000)
            };
            return format[option];
        },
        func_totalStats(session) {
            if (!session.tasks) return { fails: 0, passes: 0 };
            const data = Object.keys(session.tasks).reduce((object, taskName) => {
                const currentTask = session.tasks[taskName];
                if (currentTask.status === 'incomplete') object.fails++;
                if (currentTask.status === 'complete') object.passes++;
                return object;
            }, { fails: 0, passes: 0 });
            return data
        }
    },
    computed: {
        comp_studentOptions() {
            if (!this.data_form.class) return [];
            const [year, term] = this.data_form.class.split('.');
            return Object.keys(this.comp_classes[year][term]).map(id => {
                const comp_student = this.comp_classes[year][term][id]
                return { label: `${comp_student.firstName} ${comp_student.lastName}`, value: id }
            });
        },
        comp_classOptions() {
            return Object.keys(this.comp_classes).map((year) => {
                return { 
                    title: year, 
                    options: Object.keys(this.comp_classes[year]).map((term) => {
                        return { label: (term.charAt(0).toUpperCase() + term.slice(1)).replace(/_/g, ' '), value: term }
                    })
                };
            });
        },
        comp_classes() {
            return getClasses(this.data_students)
        },
        comp_student() {
            return this.data_students.find(({id}) => id === this.data_form.student);
        },
        comp_studentSessions() {
            return this.data_sessions.filter(({ userId }) => userId === this.data_form.student);
        },
        comp_studentPassed() {
            if (!this.comp_studentSessions.length) return 0
            const data = this.comp_studentSessions.reduce((object, session) => {
                const sessionTotal = this.func_totalStats(session);
                object.passes += sessionTotal.passes;
                object.fails += sessionTotal.fails;
                return object;
            }, { passes: 0, fails: 0 });

            return Math.round((data.passes / ( data.passes +  data.fails )) * 100);
        },
        comp_chartData() {
            const student = this.data_form.student;
            const sessions = this.data_sessions;

            const data = sessions.reduce((object, session) => {
                const key = student === session.userId ? 'student' : 'class';
                const labels = object[key].labels;
                const series = object[key].series;

                sortTasks(session.tasks).forEach((taskName, index) => {
                    const currentTask = session.tasks[taskName];
                    const name = taskName.replace('task', 'Task ');
                    if (!labels.includes(name)) labels.push(name);
                    const time =  currentTask.time;
                    if (!series[index]) series[index] = [];
                    series[index].push(time);
                });

                return object;
            }, { student: { labels: [], series: [], }, class: { labels: [], series: [], } });

            return formatChart({ data, formatter: this.func_selectFunction(this.data_form.task) });
        }
    },
    mounted() {
        this.data_loading = true;
        this.$services.users.getByInstitution(this.user.institution).then(({ docs }) => {
            this.data_students = docs.map(doc => ({...{id: doc.id}, ...doc.data()}));
            this.data_form.class = `${this.comp_classOptions[0].title}.${this.comp_classOptions[0].options[0].value}`;
            this.data_form.student = this.isTrainee ? this.$user.uid : this.comp_studentOptions[0].value;
            this.data_loading = false;
        });

        this.$services.sessions.getByInstitution(this.user.institution).then(({ docs }) => {
            this.data_sessions = docs.map(doc => ({...{id: doc.id}, ...doc.data()}));
        });
    }
}
</script>
